var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"h-stack h-end"},[(_vm.$store.state.accessLevel > 9)?_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/users/crew/add')}}},[_vm._v(" New ")]):_vm._e()]),_c('Table',{attrs:{"loading":_vm.loading,"items":_vm.users,"defaultColumn":0,"css":"200px 80px 100px 1fr 60px","columns":[
      {
        name: 'Name',
        sort: 'alphabet',
        path: ['fullName'],
      },
      {
        name: 'Birthday',
        sort: 'date',
        formatType: 'date',
        format: 'DD.MM.YYYY',
        path: ['birthday'],
      },
      {
        name: 'Phone',
        sort: 'numeric',
        path: ['phoneNumber'],
        formatType: 'phone',
      },
      {
        name: 'Email',
        sort: 'alphabet',
        path: ['email'],
      },
      {
        name: 'Hours',
        sort: 'numeric',
        path: ['totalHours'],
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/users/detail/' + $event._id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }